<div class="flex flex-col items-center bg-gray-100 dark:bg-gray-900 h-screen relative">
  <div class="mt-20 pt-24">
    <p class="sm:text-4xl text-2xl font-bold text-gray-900 dark:text-gray-100 leading-snug tracking-tighter">Welcome to FinderWise</p>
  </div>

  <div class="mt-4 w-96">
    <p class="sm:text-lg text-sm text-gray-700 dark:text-gray-300 leading-relaxed text-center">Sign in to your FinderWise account to continue</p>
  </div>

  <div class="sm:w-96 w-56 border-b border-gray-300 dark:border-gray-700 my-8"></div>

  <!-- Google Sign-In button -->
  <button *ngIf="showGoogleAuth"
          (click)="signInWithGoogle()"
          class="google-sign-in-button mt-4">
    <svg class="google-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    </svg>
    Sign in with Google
  </button>

  <!-- Dev Auth button -->
  <button *ngIf="showDevAuth"
          (click)="signInWithDevAuth()"
          class="dev-auth-sign-in-button mt-2">
    <svg class="dev-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
    </svg>
    Sign in with Dev Auth
  </button>
  
  <!-- Development notice -->
  <div class="dev-auth-notice mt-4 w-96" *ngIf="showDevAuth">
    ⚠️ Development Mode: Use Dev Auth for testing
  </div>

  <!-- Copy Console Logs Button (Development environments only) -->
  <div class="mt-4" *ngIf="isDevelopment">
    <button (click)="copyConsoleLogsToClipboard()"
            class="bg-purple-100 hover:bg-purple-200 border-2 border-purple-400 text-purple-800 px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 flex items-center space-x-2">
      <span>📋</span>
      <span>Copy Console Logs</span>
    </button>
  </div>

  <div class="absolute bottom-0 w-full text-center text-gray-400 dark:text-gray-500 text-xs">
    <p>FinderWise build: {{buildTime}} | version: {{gitSHA}}  </p>
  </div>
</div>